// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"e313e5f1","121":"180cc408","126":"5cf66977","163":"2047336d","251":"a57c10ef","317":"f35607f0","420":"1531bbea","460":"649e2c7b","606":"8b58d67e","693":"8add2873","767":"9d692806","848":"12ae6b60","916":"31f873b7"}[chunkId] + ".chunk.js";
};